import React, { Component } from "react";
import selectIcon from 'Assets/images/select-icon.svg';
import subjectDefaultData from "Pub/js/subjectDefaultData";
import platform from "Pub/js/platform";
import { langCheck } from "Pub/js/utils.js";
const { promptBox } = platform;
const { NCDropdown, NCMenu, NCTooltip } = platform.base;
const { Item } = NCMenu;
const { showColorMap } = subjectDefaultData;

export default class ThemeColor extends Component {
    constructor(props) {
        super(props);
        this.state = { showTip: false };
    }
    render() {
        const { showTip } = this.state;
        let { classNames, colorArr, setSubjectSkin, type, custom, colCount = 7, allowClick = true, getPopupContainer } = this.props;
        if (custom) { // 可自定义主题
            colorArr = colorArr.concat([
                {
                    color: "",
                    defaultShow: false,
                    fieldid: "custom",
                    key: "custom",
                    name: langCheck('0000PUB-000490'), // 自定义
                },
            ]);
        }
        // let colCount = 7; // 一行七个
        let blankArr = []; // 占位
        for (let i = 0; i < colCount; i++) {
            blankArr.push(undefined);
        }
        let rowCount = Math.ceil(colorArr.length / colCount); // 行数
        let rows = [];
        for (let i = 0; i < rowCount; i++) {
            let sliceArr = colorArr.slice(i * colCount, (i + 1) * colCount);
            if (sliceArr.length < colCount) {
                sliceArr = sliceArr.concat(blankArr).slice(0, colCount);
            }
            rows.push(sliceArr);
        }
        return (
            <div style={{ position: 'relative' }}>
                {
                    rows.map(row => {
                        return <ul className={`panel-ul ${classNames}`} >
                            {
                                row.map(item => {
                                    if (!item) { return <li style={{ visibility: 'hidden' }} className="panel-ul-li"><div className="li-top blank"></div></li>; }

                                    const { color, fieldid, name, key, defaultShow, pk_customtheme, editable } = item;
                                    return <li
                                        className='panel-ul-li'
                                        key={key || pk_customtheme}
                                        onClick={setSubjectSkin.bind(this, item)}
                                        fieldid={fieldid}
                                    >
                                        <div className={defaultShow ? "select-bg li-top" : "li-top"}>
                                            <div
                                                className="li-top-bg"
                                                style={color.indexOf('default') !== -1 ? { background: `url(${showColorMap[color]}) center center` } : { backgroundColor: showColorMap[color] || color }}
                                            >
                                                {key === 'custom' && <i
                                                    fieldid="theme-add"
                                                    className="iconfont icon-ncc-sq"
                                                ></i>}
                                                {defaultShow && <img className="select-icon" src={selectIcon} alt="" />}
                                            </div>
                                        </div>
                                        <NCTooltip
                                            placement="bottom"
                                            overlay={showTip ? name : ''}
                                            inverse
                                        >
                                            <span
                                                className={`name theme-name ${defaultShow ? 'name-select' : ''}`}
                                                onMouseEnter={e => {
                                                    const tipNode = e.target;
                                                    if (tipNode) {
                                                        if (tipNode.scrollWidth > tipNode.clientWidth) {
                                                            !showTip && this.setState({ showTip: true });
                                                        } else {
                                                            showTip && this.setState({ showTip: false });
                                                        }
                                                    }
                                                }}
                                            >
                                                {name}
                                            </span>
                                        </NCTooltip>
                                        {type === 'sebjectSetting' && pk_customtheme && editable && <div onClick={e => e.stopPropagation()}>
                                            <NCDropdown
                                                getPopupContainer={getPopupContainer}
                                                trigger={['click']}
                                                placement="bottomRight"
                                                overlay={<NCMenu onClick={({ key }) => {
                                                    this.handleTheme(key, item);
                                                }}>
                                                    <Item fieldid={`theme-edit-${name}`} key="themeEdit">{langCheck('0000PUB-000489') /*编辑*/}</Item>
                                                    <Item fieldid={`theme-delete-${name}`} disabled={defaultShow} key="themeDelete">{langCheck('0000PUB-000005') /*删除 */}</Item>
                                                </NCMenu>}
                                                animation="slide-up"
                                            >
                                                <i fieldid={`theme-opr-${name}`} style={{ cursor: 'pointer' }} className="iconfont icon-gengduo"></i>
                                            </NCDropdown>
                                        </div>}
                                    </li>;
                                },
                                )
                            }
                        </ul >;
                    })
                }
                {!allowClick && <div className='show-shade' style={{ top: 0 }} onClick={this.handleShade}></div> /** 无权限时遮罩置灰 */}

            </div>
        );
    }

    handleTheme(key, theme) {
        const { handleTheme = () => { } } = this.props;
        if (key === 'themeDelete') {
            promptBox({
                color: 'warning',
                title: langCheck('0000PUB-000006'), // 确定要删除吗？
                beSureBtnClick: () => { handleTheme(key, theme); },
            });
            return;
        }

        handleTheme(key, theme);
    }
}
